import foundRoutes from "./Found";

const foundRoutesMap = {
  ...foundRoutes,
};

export default foundRoutesMap;
